import React from 'react';
import classnames from 'classnames';
import { AvatarProps } from '../../types.d';

import styles from '../../Avatar.module.scss';

function MentorHappy({
  size,
  className,
}: Pick<AvatarProps, 'size' | 'className'>): JSX.Element {
  return (
    <svg
      className={classnames(className, {
        [styles[size]]: size,
      })}
      x="0px"
      y="0px"
      viewBox="0 0 144 144"
      enableBackground="new 0 0 144 143.996"
      xmlSpace="preserve"
    >
      <g id="ponos">
        <g id="happy">
          <ellipse
            fill="#A6E3F9"
            cx="72"
            cy="71.996"
            rx="72"
            ry="71.998"
          />
          <g>
            <defs>
              <ellipse
                id="SVGID_17_"
                cx="72"
                cy="71.998"
                rx="72"
                ry="71.998"
              />
            </defs>
            <clipPath id="SVGID_2_">
              <use
                xlinkHref="#SVGID_17_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_2_)">
              <rect
                x="6.484"
                y="99.62"
                transform="matrix(0.8329 0.5534 -0.5534 0.8329 59.1564 12.5937)"
                fill="#00AFEC"
                width="4.475"
                height="9.295"
              />
              <rect
                x="75.276"
                y="-4.643"
                transform="matrix(0.866 -0.5 0.5 0.866 10.3821 38.7564)"
                fill="#00AFEC"
                width="4.475"
                height="9.295"
              />
              <rect
                x="117.276"
                y="120.245"
                transform="matrix(0.8124 -0.583 0.583 0.8124 -50.4019 93.1065)"
                fill="#FFE502"
                width="4.475"
                height="9.295"
              />
              <rect
                x="127.746"
                y="54.694"
                transform="matrix(0.8124 -0.583 0.583 0.8124 -10.2187 86.9164)"
                fill="#FFE502"
                width="4.475"
                height="9.295"
              />
              <rect
                x="11.814"
                y="62.399"
                transform="matrix(0.8897 0.4566 -0.4566 0.8897 32.1647 0.9815)"
                fill="#FFE502"
                width="4.475"
                height="9.295"
              />
              <rect
                x="121.977"
                y="73.245"
                transform="matrix(-0.7662 0.6426 -0.6426 -0.7662 269.4413 57.7477)"
                fill="#00AFEC"
                width="4.475"
                height="9.295"
              />
              <rect
                x="19.429"
                y="15.512"
                transform="matrix(0.8329 0.5534 -0.5534 0.8329 14.7758 -8.6219)"
                fill="#FFE502"
                width="4.475"
                height="9.295"
              />
              <rect
                x="95.251"
                y="15.512"
                transform="matrix(0.8329 0.5534 -0.5534 0.8329 27.4433 -50.5799)"
                fill="#FFE502"
                width="4.475"
                height="9.295"
              />
              <rect
                x="4.582"
                y="40.401"
                transform="matrix(-0.7662 0.6426 -0.6426 -0.7662 40.9944 75.1808)"
                fill="#00AFEC"
                width="4.475"
                height="9.295"
              />
            </g>
          </g>
          <g>
            <defs>
              <ellipse
                id="SVGID_19_"
                cx="72"
                cy="72"
                rx="72"
                ry="71.998"
              />
            </defs>
            <clipPath id="SVGID_4_">
              <use
                xlinkHref="#SVGID_19_"
                overflow="visible"
              />
            </clipPath>
            <g clipPath="url(#SVGID_4_)">
              <path
                fill="#42291C"
                d="M50.014,58.654c0.468,6.161-4.148,11.534-10.308,12.002c-6.161,0.468-11.534-4.148-12.002-10.308 c-0.468-6.161,4.148-11.534,10.309-12.002C44.174,47.878,49.547,52.494,50.014,58.654z"
              />
              <ellipse
                transform="matrix(0.2207 -0.9753 0.9753 0.2207 -8.5247 78.4392)"
                fill="#42291C"
                cx="44.822"
                cy="44.554"
                rx="14.453"
                ry="14.453"
              />
              <path
                fill="#42291C"
                d="M84.567,58.559l-3.771,0.286l-1.932-25.452l3.771-0.286c7.028-0.533,13.159,4.732,13.692,11.76l0,0 C96.861,51.895,91.595,58.025,84.567,58.559z"
              />
              <path
                fill="#42291C"
                d="M56.195,81.766l-9.791,0.743c-5.005,0.38-9.37-3.37-9.75-8.375l-0.811-10.691l18.854-1.431 L56.195,81.766z"
              />
              <path
                fill="#42291C"
                d="M83.323,56.949l-10.631,0.807l-2.486-32.753l9.589-0.728c6.006-0.456,11.244,4.044,11.7,10.05 l0.914,12.045C92.821,51.801,88.753,56.537,83.323,56.949z"
              />
              <ellipse
                transform="matrix(0.9079 -0.4192 0.4192 0.9079 -9.6932 27.2683)"
                fill="#42291C"
                cx="57.213"
                cy="35.695"
                rx="16.607"
                ry="16.607"
              />
              <path
                fill="#00AFEC"
                d="M77.524,110.822c-6.343,4.166-8.107,12.686-3.941,19.029c0.334,0.508,0.705,0.975,1.091,1.424 l-0.011,0.008l37.834,43.968l15.907-12.005l-31.85-48.484C92.387,108.419,83.867,106.655,77.524,110.822z"
              />
              <circle
                fill="#00AFEC"
                cx="84.684"
                cy="122.462"
                r="14.136"
              />
              <path
                fill="#00AFEC"
                d="M98.744,123.115l-3.659,79.075H44.518l-20.896-83.042c-1.382-5.493,2.771-10.822,8.436-10.822h52.565 C92.687,108.326,99.117,115.06,98.744,123.115z"
              />
              <path
                fill="#00AFEC"
                d="M42.027,111.969c-5.795-5.231-14.734-4.775-19.966,1.02c-0.419,0.464-0.788,0.955-1.134,1.455 l-0.011-0.009l-33.941,49.079L3.057,176.23l39.991-44.296C48.279,126.139,47.822,117.2,42.027,111.969z"
              />
              <path
                fill="#283042"
                d="M101.061,58.588c-0.012,0.009-0.012,0.009-0.012,0.009"
              />
              <path
                fill="#FDC9A3"
                d="M53.694,110.228c1.065,6.52,7.213,10.941,13.733,9.876c6.52-1.065,10.942-7.213,9.877-13.733 c-1.065-6.52-7.213-10.941-13.733-9.876C57.051,97.56,52.629,103.708,53.694,110.228z"
              />
              <polygon
                fill="#FDC9A3"
                points="77.304,106.371 53.694,110.228 48.945,81.156 49.638,81.043 72.555,77.3"
              />
              <path
                fill="#FDC9A3"
                d="M63.969,28.386l-1.836,0.3C50.412,30.6,42.463,41.652,44.378,53.372l6.529,39.974l22.229-3.631 c11.163-1.823,18.735-12.351,16.911-23.514l-3.528-21.597C84.771,33.898,74.674,26.637,63.969,28.386z"
              />
              <ellipse
                transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.3029 3.7598)"
                fill="#0E0E11"
                cx="65.872"
                cy="61.199"
                rx="1.621"
                ry="2.092"
              />
              <ellipse
                transform="matrix(0.9985 -0.0556 0.0556 0.9985 -3.2379 4.5359)"
                fill="#0E0E11"
                cx="79.844"
                cy="60.42"
                rx="1.621"
                ry="2.092"
              />
              <path
                fill="#42291C"
                d="M89.677,46.281l-21.474,1.63c-8.752,0.664-16.412-5.916-17.076-14.667 c-0.316-4.165,2.804-7.798,6.969-8.114s7.798,2.804,8.114,6.969c0.033,0.435,0.413,0.762,0.849,0.729l21.474-1.63L89.677,46.281z"
              />
              <path
                fill="#42291C"
                d="M78.999,26.649c0.318,4.187-2.819,7.839-7.006,8.157c-4.187,0.318-7.839-2.819-8.157-7.006 c-0.318-4.187,2.819-7.839,7.006-8.157C75.029,19.325,78.681,22.462,78.999,26.649z"
              />
              <path
                fill="#42291C"
                d="M50.608,31.562l3.554-0.27l2.24,29.518c0.25,3.297-2.22,6.173-5.517,6.423l-15.709,1.192l-1.318-17.363 C33.099,41.052,40.598,32.321,50.608,31.562z"
              />
              <path
                fill="#42291C"
                d="M81.092,39.347l-10.684,0.811c-4.165,0.316-7.798-2.804-8.114-6.969 c-0.316-4.165,2.804-7.798,6.969-8.114l10.683-0.811c4.165-0.316,7.798,2.804,8.114,6.969 C88.377,35.398,85.256,39.031,81.092,39.347z"
              />
              <path
                fill="#FDC9A3"
                d="M45.051,69.451l4.88-0.793l-0.791-4.87c-0.437-2.689-2.976-4.514-5.671-4.076l0,0 c-2.695,0.438-4.526,2.974-4.089,5.663l0,0C39.817,68.064,42.356,69.889,45.051,69.451z"
              />
              <path
                fill="#42291C"
                d="M91.487,80.836c0.853,4.039-2.31,8.026-6.948,8.742l-15.074,1.195 c-8.953,1.384-17.198-3.885-18.417-11.768l-1.435-12.304l3.922-5.027c0,0,1.649,5.828,2.373,6.993 c1.28,2.059,4.053,3.51,7.746,2.939l26.639-3.036L91.487,80.836z"
              />
              <path
                fill="#FFFFFF"
                d="M68.877,74.6c0.369,3.282,3.33,5.644,6.612,5.275c3.282-0.369,5.644-3.33,5.275-6.612L68.877,74.6z"
              />
              <path
                fill="#0E0E11"
                d="M83.138,55.25c-0.017,0-0.034-0.001-0.05-0.003l-5.714-0.678c-0.232-0.028-0.399-0.238-0.371-0.471 c0.027-0.233,0.252-0.396,0.47-0.371l5.714,0.678c0.232,0.028,0.399,0.238,0.371,0.471C83.533,55.092,83.349,55.25,83.138,55.25z"
              />
              <path
                fill="#0E0E11"
                d="M62.525,56.737c-0.192,0-0.365-0.13-0.412-0.325c-0.055-0.227,0.085-0.456,0.313-0.511l6.065-1.459 c0.234-0.056,0.456,0.086,0.511,0.313c0.055,0.227-0.085,0.456-0.313,0.511l-6.065,1.459 C62.591,56.733,62.557,56.737,62.525,56.737z"
              />
            </g>
            <g clipPath="url(#SVGID_4_)">
              <line
                fill="none"
                stroke="#0E0E11"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                x1="70"
                y1="60.932"
                x2="75.913"
                y2="60.575"
              />
              <circle
                fill="none"
                stroke="#0E0E11"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                cx="66.012"
                cy="61.154"
                r="3.994"
              />
              <circle
                fill="none"
                stroke="#0E0E11"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="10"
                cx="80.066"
                cy="60.371"
                r="3.994"
              />
            </g>
          </g>
          <path
            fill="#FFE500"
            d="M48.733,40.356c-0.268-1.071-1.181-32.137-1.181-32.137l19.401,26.248L48.733,40.356z"
          />
        </g>
      </g>
    </svg>
  );
}

export default MentorHappy;
